import Relay from 'react-relay';

export const ViewerFragment = Relay.QL`
    fragment on Viewer {
        user(userId: $userId) {
            isVerifiedTrade
            verifiedTradeSubStatus
        }
        item(itemId: $itemId) {
            pricing {
                prices {
                    type
                    status
                    amount {
                        convertedAmounts {
                            USD
                        }
                    }
                }
            }
        }
        confirmedTransactions: transactions(buyerId: $userId, viewName: "buyerTracking.confirmed", first: 0) {
            totalResults
        }
    }
`;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/VerifiedTradePromo/verifiedTradePromoFragments.es.js